export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('VideoPlayer', () => ({
        video: null,
        isPlaying: false,

        assignIdToVideo() {
          const videoElement = document.getElementById('video-placeholder');

          // Assign Alpine video reference
          this.video = videoElement;

          // Listen for play/pause events
          videoElement.addEventListener('play', () => {
            this.isPlaying = true;
          });

          videoElement.addEventListener('pause', () => {
            this.isPlaying = false;
          });
        },

        playPause() {
          if (!this.video) return;
          this.video.paused ? this.video.play() : this.video.pause();
        },
      }));
    });
  },
};
